export default __webpack_public_path__ + "static/media/OTListOff.9d7e5412.svg";